export const defaultParams = {
  with_backfill: 1
}
export const defaultSelectedJobId = null

export const defaultSourceJobId = null

export const defaultResultsLoading = false

export const defaultItems = []

export const defaultTotalCount = 0

export const defaultJobsResults = {
  items: defaultItems,
  loading: defaultResultsLoading,
  totalCount: defaultTotalCount
}

export default {
  params: defaultParams,
  selectedJobId: defaultSelectedJobId,
  sourceJobId: defaultSourceJobId,
  jobsResults: defaultJobsResults
}
